// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1-Wf6","productName":"Table_productName__3LdpY"};